import moment from 'moment-timezone';
import {PcBangContentStack} from '../components/Common/PcBangContentStack';
import {compareDateTime} from '../util/timeUtils';

export const PC_BANG_MAIN_BANNERS_REQUEST = 'PC_BANG_MAIN_BANNERS_REQUEST';
export const PC_BANG_MAIN_BANNERS_RESPONSE = 'PC_BANG_MAIN_BANNERS_RESPONSE';

export function pcBangMainBannersRequest() {
  return {
    type: PC_BANG_MAIN_BANNERS_REQUEST,
  };
}

export function pcBangMainBannersResponse(mainBanners) {
  return {
    type: PC_BANG_MAIN_BANNERS_RESPONSE,
    mainBanners,
  };
}

export function fetchPcBangMainBanners() {
  return dispatch => {
    dispatch(pcBangMainBannersRequest());
    PcBangContentStack.ContentType('pcb_banner')
      .Query()
      .toJSON()
      .find()
      .then(result => result[0])
      .then(mainBanners => {
        mainBanners = mainBanners.filter(mainBanner => _isMainBannerInValidPeriodAndStatus(mainBanner));
        mainBanners.sort((banner1, banner2) => compareDateTime(banner1.start_date, banner2.start_date));
        dispatch(pcBangMainBannersResponse(mainBanners));
      });
  };
}

const _isMainBannerInValidPeriodAndStatus = mainBanner => {
  let currentMoment = moment();
  if (mainBanner.start_date && moment.utc(mainBanner.start_date).isAfter(currentMoment)) {
    return false;
  } else if (mainBanner.end_date && moment.utc(mainBanner.end_date).isBefore(currentMoment)) {
    return false;
  }
  return true;
};
